import { ReactElement, ReactNode, useEffect } from 'react'
import { useLocation } from 'wouter'
import { useUserContext } from '@app/util/hooks/useUserContext'
import { pages } from '@app/util/links'

export const ProtectedRoute = ({
  children,
}: {
  children: ReactNode
}): ReactElement | null => {
  const { isAuthenticated, isLoading } = useUserContext()
  const [location, navigate] = useLocation()

  useEffect(() => {
    if (!isLoading && !isAuthenticated) {
      navigate(`${pages.login}?redirectTo=${encodeURIComponent(location)}`, {
        replace: true,
      })
    }
  }, [isAuthenticated, isLoading, navigate, location])

  if (isLoading || !isAuthenticated) return null

  return <>{children}</>
}
